import React from "react"
import { Label as RebassLabel } from "rebass"

const Label = props => <RebassLabel {...props} fontSize={[2, 3, 4]} />

export default Label



// WEBPACK FOOTER //
// ./src/components/Label.js